// extracted by mini-css-extract-plugin
module.exports = {"root":"effects-section_root__1mZCL"};